import { createSlice } from '@reduxjs/toolkit'

export const loadingSlice = createSlice({
  name: 'loading',
  initialState: 0,
  reducers: {
    startLoading: (state) => {
      if (state >= 0) return state + 1
      return 1
    },
    stopLoading: (state) => {
      if (state > 0) return state - 1
      return 0
    },
  },
})

const { actions = {} } = loadingSlice
export default loadingSlice.reducer

export const startLoading = () => (dispatch) => {
  dispatch(actions.startLoading())
}

export const stopLoading = () => (dispatch) => {
  dispatch(actions.stopLoading())
}

export const selectLoading = (state) => state.loading
export const selectorLoading = (state) => state.loading
